var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollable scrollbar-grey"},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},_vm._l((_vm.slides),function(slide,index){return _c('div',{key:slide.id_campagna,staticClass:"pa-4",class:{
        'row-even': index % 2 === 0,
        white: index % 2 !== 0,
      }},[(slide.checked == undefined || slide.checked)?_c('Card',{attrs:{"id_campagna":slide.id_campagna,"confirmed":slide.confirmed,"type":slide.type,"titolo":slide.campaign_name,"data":slide.data,"video-preview":slide.videoPreview != undefined
            ? slide.videoPreview
            : false}}):_vm._e()],1)}),0),_c('div',{staticClass:"force-overflow"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }